/**
 * SalesHistoryTienda.jsx
 * ─────────────────────────────────────────────────────────────────────────────
 * Wrapper de SalesHistory para TIENDA GENERAL.
 * El historial base (SalesHistory) es compatible con ambos tipos, así que
 * este componente actúa como punto de entrada tipado para tienda.
 * En el futuro se pueden agregar columnas o filtros exclusivos de tienda aquí.
 * ─────────────────────────────────────────────────────────────────────────────
 */
import React from 'react';
import SalesHistory from './SalesHistory';

const SalesHistoryTienda = ({ sales, onRefresh }) => {
    return (
        <SalesHistory
            sales={sales}
            onRefresh={onRefresh}
            tipoNegocio="tienda_general"
        />
    );
};

export default SalesHistoryTienda;
